<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>협회 소개</p></li>
            <li><p>CI</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>CI / 브로슈어</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="rule_list">
            <ul class="rule_list_ul">
              <li class="rule_list_li">
                <div class="rule_list_ttl">
                  <h3 class="h3">시그니처</h3>
                </div>
                <div class="rule_list_con">
                  <div class="ci_list">
                    <ul class="ci_list_ul">
                      <li class="ci_list_li">
                        <div class="left">
                          <div class="ci_list_ttl">
                            <span>시그니처 기본</span>
                          </div>
                          <div class="btn_wrap">
                            <button class="down_btn" @click="fnFileDown('ci/3a4c543ef65044428a4c3b14b35f0dcf.jpg', '시그니처기본.jpg')"><span>JPG 다운로드</span></button>
                            <button class="down_btn ai" @click="fnFileDown('ci/aeee3a8eed0043b4b8c2eaef4f0dc8ce.ai', '시그니처기본.ai')"><span>AI 다운로드</span></button>
                          </div>
                        </div>
                        <div class="right">
                          <div class="logo type01">
                            <img src="@/assets/static/images/logo_type02.svg" alt="시그니처 기본">
                          </div>
                        </div>
                      </li>
                      <li class="ci_list_li">
                        <div class="left">
                          <div class="ci_list_ttl">
                            <span>시그니처 국문,영문 조합 세로타입</span>
                          </div>
                          <div class="btn_wrap">
                            <button class="down_btn" @click="fnFileDown('ci/095ce7bd53c64ed3b17512cfcdb18d43.jpg', '시그니처 국문영문조합.jpg')"><span>JPG 다운로드</span></button>
                            <button class="down_btn ai" @click="fnFileDown('ci/63c729749fed4648ab7ba20af7b49552.ai', '시그니처 국문영문조합.ai')"><span>AI 다운로드</span></button>
                          </div>
                        </div>
                        <div class="right">
                          <div class="logo type01">
                            <img src="@/assets/static/images/logo_type03.svg" alt="시그니처 국문,영문 조합 세로타입">
                          </div>
                        </div>
                      </li>
                      <li class="ci_list_li">
                        <div class="left">
                          <div class="ci_list_ttl">
                            <span>시그니처 국문 조합</span>
                          </div>
                          <div class="btn_wrap">
                            <button class="down_btn" @click="fnFileDown('ci/e956726896124ee3871c919a6b520bee.JPG', '시그니처 국문 조합.JPG')"><span>JPG 다운로드</span></button>
                            <button class="down_btn ai" @click="fnFileDown('ci/63c729749fed4648ab7ba20af7b49552.ai', '시그니처 국문 조합.ai')"><span>AI 다운로드</span></button>
                          </div>
                        </div>
                        <div class="right">
                          <div class="logo type02">
                            <img src="@/assets/static/images/logo_type04.svg" alt="시그니처 국문 조합">
                          </div>
                        </div>
                      </li>
                      <li class="ci_list_li">
                        <div class="left">
                          <div class="ci_list_ttl">
                            <span>시그니처 국문 영문 조합</span>
                          </div>
                          <div class="btn_wrap">
                            <button class="down_btn" @click="fnFileDown('ci/f7a271cd664a47b6ae427a7fc220fb32.Jpg', '시그니처 국문영문조합 세로타입.Jpg')"><span>JPG 다운로드</span></button>
                            <button class="down_btn ai" @click="fnFileDown('ci/5a32e00e732f4fc58f27cb8caf11f2ed.ai', '시그니처 국문영문조합 세로타입.ai')"><span>AI 다운로드</span></button>
                          </div>
                        </div>
                        <div class="right">
                          <div class="logo type02">
                            <img src="@/assets/static/images/logo_type01.svg" alt="시그니처 국문 영문 조합">
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li class="rule_list_li">
                <div class="rule_list_ttl">
                  <h3 class="h3">앰블럼</h3>
                </div>
                <div class="rule_list_con">
                  <div class="ci_list">
                    <ul class="ci_list_ul">
                      <li class="ci_list_li">
                        <div class="left">
                          <div class="ci_list_ttl">
                            <span>기본형</span>
                          </div>
                          <div class="btn_wrap">
                            <button class="down_btn" @click="fnFileDown('ci/46eb24a22f9b4bd486c6f17b0ca52757.jpg', '엠블렘.jpg')"><span>JPG 다운로드</span></button>
                            <button class="down_btn ai" @click="fnFileDown('ci/c42d425086fd4ec1b6c82fa991c916e5.ai', '엠블렘.ai')"><span>AI 다운로드</span></button>
                          </div>
                        </div>
                        <div class="right">
                          <div class="logo type03">
                            <img src="@/assets/static/images/logo_emblem.svg" alt="기본형">
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li class="rule_list_li">
                <div class="rule_list_ttl">
                  <h3 class="h3">브로슈어</h3>
                </div>
                <div class="rule_list_con">
                  <div class="intro_brochure">
                    <div class="img_area">
                      <img src="@/assets/static/images/img_brochure.png" alt="">
                    </div>
                    <div class="intro_brochure_ttl">
                      <span>한국 외식 산업협회 소개 브로슈어</span>
                    </div>
                    <button class="down_btn pdf" @click="fnFileDown('ci/944b266172344bc2b3824c4e3f4460d6.pdf', '(사)한국외식산업협회 브로슈어.pdf')"><span>PDF 다운로드</span></button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'about-ci-index',
  description: 'ci',
  methods: {
    fnFileDown: function(path, name) {
      let params = {}
      params.fileName = name
      params.filePath = path
      this.$CommonSvc.downloadFile(params).then(res => {
        if (!this.$Util.isEmpty(name)) {
          const blob = new Blob([res.data], {
            type: res.data.type,
            encoding: 'UTF-8'
          })
          const a = document.createElement('a')
          a.href = URL.createObjectURL(blob)
          a.download = name
          a.target = '_blank'
          a.click()
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
